interface IconProps {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
}

export const BankIcon = ({
  size = 25,
  width,
  height,
  fill = "white",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width || size}
      height={height || size * (24 / 25)}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.0834 9.04011L4.0834 8.45344V10.6668H21.4167V8.47344L22.4034 9.04011C22.5558 9.11981 22.733 9.13756 22.8982 9.08966C23.0633 9.04175 23.2035 8.93189 23.2896 8.78302C23.3756 8.63415 23.4009 8.45779 23.3599 8.29078C23.319 8.12377 23.2152 7.97902 23.0701 7.88678L12.7501 1.94678L2.41673 7.88678C2.33706 7.92845 2.26665 7.98582 2.20972 8.05541C2.15279 8.12501 2.11053 8.2054 2.08548 8.29175C2.06043 8.3781 2.0531 8.46863 2.06395 8.55789C2.07479 8.64715 2.10357 8.73329 2.14857 8.81113C2.19357 8.88897 2.25384 8.95691 2.32578 9.01085C2.39771 9.0648 2.47981 9.10363 2.56714 9.12502C2.65447 9.14642 2.74523 9.14992 2.83395 9.13533C2.92267 9.12074 3.00752 9.08835 3.0834 9.04011ZM12.6501 4.74011C12.7311 4.6933 12.8231 4.66866 12.9167 4.66866C13.0104 4.66866 13.1023 4.6933 13.1834 4.74011L17.6634 7.33344H15.5167L12.9167 5.84011L10.3167 7.33344H8.17673L12.6501 4.74011Z"
        fill={fill}
      />
      <path
        d="M22.6502 18.0001H22.0835V17.4334C22.0835 17.2301 22.0027 17.0351 21.8589 16.8913C21.7152 16.7475 21.5202 16.6668 21.3168 16.6668H19.4168V11.7534H16.7502V16.6668H14.0835V11.7534H11.4168V16.6668H8.75016V11.7534H6.0835V16.6668H4.1835C3.98016 16.6668 3.78516 16.7475 3.64138 16.8913C3.4976 17.0351 3.41683 17.2301 3.41683 17.4334V18.0001H2.85016C2.64683 18.0001 2.45183 18.0809 2.30805 18.2246C2.16427 18.3684 2.0835 18.5634 2.0835 18.7668V20.6668H23.4168V18.7668C23.4168 18.5634 23.3361 18.3684 23.1923 18.2246C23.0485 18.0809 22.8535 18.0001 22.6502 18.0001Z"
        fill={fill}
      />
    </svg>
  );
};

export default BankIcon;
